@if (isVisible) {
  <ds-banner
    class="d-block mb-4"
    [state]="DsBannerState.error"
    [showTitle]="false"
    [showAction]="false"
    data-test-id="error-userway-sso-banner"
    [showCloseButton]="true"
    (closed)="closed.emit()"
  >
    <div ds-banner-body>
      <p class="mb-0">
        {{ 'widget_sso_error' | translate }}
        <ds-link [external]="true" href="https://client.levelaccess.com/hc/en-us/requests/new">
          {{ 'widget_support' | translate }}
        </ds-link>
        .
      </p>
    </div>
  </ds-banner>
}
